/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { History } from "history";
import type { FC, ReactNode } from "react";
import { StaticRouter } from "react-router-dom/server";

import { useServer } from "@shared/hooks";
import type { BrowserRouterProps } from "@shared/react-router-dom";

import { BrowserRouter } from "./BrowserRouter";

interface Props extends BrowserRouterProps {
  history?: History;
  children: ReactNode;
}

const Router: FC<Props> = ({ children, ...rest }) => {
  const { ssr, url } = useServer();

  if (ssr) {
    return <StaticRouter location={url}>{children}</StaticRouter>;
  }

  return <BrowserRouter {...rest}>{children}</BrowserRouter>;
};

export { Router };
